<template>
    <thead :class="style['mds-data-table__header']">
        <tr :class="[style['mds-data-table__row']]" ref="row">
            <th
                :class="[style[('mds-data-table__header-cell', 'mds-data-table__header-selection')]]"
                scope="col"
                ref="checkboxCell"
                v-if="multiSelect"
            >
                <div :class="[style['mds-data-table__header-cell-selection']]">
                    <mds-checkbox
                        ref="checkbox"
                        :hidden-label="true"
                        :label="headerConfigs[0].text || headerConfigs[0].fieldName"
                        @change="emitHeaderSelectAll"
                        :checked="isChecked"
                        :indeterminate="setIndeterminate"
                    />
                </div>
            </th>
            <slot name="index-header">
                <th
                    :class="[style[('mds-data-table__header-cell', 'mds-data-table__header-numbered')]]"
                    v-if="rowNumber"
                >
                    <div :class="[style['mds-data-table__header-cell-inner']]" />
                </th>
            </slot>
            <mds-data-table-header-cell
                v-for="(config, colIndex) in headerConfigs"
                ref="cell"
                :key="colIndex"
                :style="null"
                v-bind="updateResponsiveColumnWidth({ config, colIndex })"
                @mds-data-table-header-action-click="emitHeaderActionClicked"
                @mds-data-table-sort-change="emitSortFieldChange({ colIndex, arguments })"
            >
                <slot name="header-cell" :content="config.text" :colIndex="colIndex">{{ config.text }}</slot>
                <template v-slot:action>
                    <slot name="action-cell" :colIndex="colIndex" />
                </template>
            </mds-data-table-header-cell>
        </tr>
    </thead>
</template>

<script>
    import MdsCheckbox from '@mds/checkbox';
    import MdsDataTableHeaderCell from './data-table-header-cell.vue';

    export default {
        name: 'MdsDataTableHeader',
        components: {
            MdsCheckbox,
            MdsDataTableHeaderCell,
        },
        props: {
            headerConfigs: {
                type: Array,
                default: () => [],
                docs: {
                    validation: '—',
                    description:
                        'Set of objects that describe each header column. See the header cell props for a definition of all properties.',
                },
            },
        },
        inject: ['parentVariation'],
        provide() {
            const headerVariation = {};
            Object.defineProperty(headerVariation, 'style', {
                get: () => this.style,
            });
            return { headerVariation };
        },
        data() {
            return {
                height: null,
                sortField: '',
                sortOrder: 0,
                setIndeterminate: false,
                isChecked: false,
                style: this.parentVariation.style,
            };
        },
        computed: {
            multiSelect() {
                return this.parentVariation && this.parentVariation.multiSelect;
            },
            rowNumber() {
                return this.parentVariation && (this.parentVariation.rowNumber || this.rowNumbering);
            },
            responsive() {
                return this.parentVariation && this.parentVariation.responsive;
            },
        },
        methods: {
            emitHeaderSelectAll(checked) {
                this.$emit('mds-data-table-header-select-all', checked);
            },
            emitSortFieldChange(ev) {
                const fieldName = ev.arguments[0];
                const colIndex = ev.colIndex;

                if (this.sortField === fieldName) {
                    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
                } else {
                    this.sortOrder = this.headerConfigs[colIndex].sorted || 1;
                }
                this.sortField = fieldName;
                const obj = {
                    sortField: this.sortField,
                    sortOrder: this.sortOrder,
                };

                this.updateCellsOnSort();
                this.$emit('mds-data-table-sort-change', obj);
            },
            updateCellsOnSort() {
                this.$refs.cell.forEach(cell => {
                    if (cell.fieldName !== this.sortField) {
                        cell.sortField = false;
                        cell.sortOrder = 0;
                    } else {
                        cell.sortField = true;
                        cell.sortOrder = this.sortOrder;
                    }
                });
            },
            updateResponsiveColumnWidth(ev) {
                if (this.responsive && ev.colIndex === 0) {
                    ev.config.width = null;
                    return ev.config;
                }
                return ev.config;
            },
            emitHeaderActionClicked(ev) {
                this.$emit('mds-data-table-header-action-click', ev);
            },
        },
    };
</script>
